module.exports = __webpack_public_path__ + "static/img/wap.cabbb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/国际高中/wap.svg
// module id = ezba
// module chunks = 16